import React, { Component } from 'react'

class LoadingBox extends Component {
	render() {
		return (
			<div className="wrap_loading">
				<span className="ico_blog ico_loading"/>
				<p className="txt_loading">로딩중입니다</p>
			</div>
		)
	}
}

export default LoadingBox
